import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EcommerceProductSummaryDto } from '../../interfaces/ecommerce-product-summary.dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root",
})
export class ListingsService {
  private readonly baseUrl = environment.apiNestJS;

  constructor(private readonly http: HttpClient) {}

  getProductSummaryById(id: number): Observable<EcommerceProductSummaryDto> {
    return this.http.get<EcommerceProductSummaryDto>(
      `${this.baseUrl}/ecommerce-products/${id}/summary`,
    );
  }
}
